module.exports = __webpack_public_path__ + "assets/img/line3.5c1a496a.png";